<template>
  <div class="fixed_popup">
    <div class="row m-0 justify-content-center align-items-center h-100" @click.self="closeRegister">
      <div class="col-md-7 col-lg-6 col-sm-12 mt-3">
        <div @click="closeRegister" class="close_icon">
          <ios-close-icon />
        </div>
        <form class="form_holder p-3" id="register-form" role="form" @submit.prevent="onSubmit">
          <h3 class="text-center">Register</h3>
          <div class="row m-0 p-4">
            <div class="col-12 p-0">
              <div class="form-group">
                <input
                  type="text"
                  name="name"
                  id="name"
                  class="form-control"
                  placeholder="First Name"
                  value
                  v-model="firstname"
                  required
                />
              </div>
              <div class="form-group">
                <input
                  type="text"
                  name="lastname"
                  id="lastname"
                  class="form-control"
                  placeholder="Last Name"
                  value
                  v-model="lastname"
                  required
                />
              </div>
              <div class="form-group">
                <input
                  type="tel"
                  name="mobile"
                  id="mobile"
                  class="form-control"
                  placeholder="Mobile Number"
                  value
                  v-model="mobile"
                  required
                />
              </div>
              <div class="form-group">
                <input
                  type="email"
                  name="email"
                  id="email"
                  class="form-control"
                  placeholder="Email Address"
                  value
                  v-model="email"
                  required
                />
              </div>
              <div class="form-group">
                <input
                  type="password"
                  name="password"
                  id="password"
                  class="form-control"
                  placeholder="Password"
                  v-model="password"
                  required
                />
              </div>
              <div class="form-group mt-5">
                <button class="btn btn-outline" style="width: 100%" :disabled="isLoading" @click="register">
                  <i v-if="isLoading" class="fa fa-spinner fa-spin" />
                  Register
                </button>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="text-center smaller_font">
                      Already have an account? <a @click="login" class="cursor">Login</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      firstname: '',
      lastname: '',
      mobile: '',
      email: '',
      password: '',
      isLoading: false
    }
  },
  methods: {
    ...mapActions(['clearMessage', 'addMessage', 'registerByEmail', 'saveUserDetails']),
    register () {
      this.isLoading = true
      let data = {
        email: this.email,
        password: this.password
      }
      this.registerByEmail(data).then((userCredential) => {
        this.saveUserDetails({
          uid: userCredential.user.uid,
          firstname: this.firstname,
          lastname: this.lastname,
          mobile: this.mobile
        })
        this.clearMessage()
        this.closeRegister()
      })
        .catch((error) => {
          // console.log('register error', error);
          let messageObj = {
            message: error.message,
            messageClass: 'danger',
            autoClose: true
          }
          this.addMessage(messageObj)
        }).then(() => {
          this.isLoading = false
        })
    },
    onSubmit () {
      console.log('submit')
    },
    login () {
      this.$emit('goToLogin')
    },
    closeRegister () {
      this.$emit('closeRegister')
    }
  }
}
</script>

<style scoped>
.fixed_popup {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--dark-color-08);
}
.close_icon {
  position: absolute;
  right: 15px;
  top: 0;
  text-align: right;
  color: var(--dark-color);
}
.dark-mode .close_icon {
  color: var(--light-color);
}
.smaller_font {
  font-size: small;
}
</style>
